import { render, staticRenderFns } from "./modules.vue?vue&type=template&id=2b7ee5f4&"
import script from "./modules.vue?vue&type=script&lang=js&"
export * from "./modules.vue?vue&type=script&lang=js&"
import style0 from "./modules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports